import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import  AdminSidebar  from "./Admin";
import ClientSidebar from "./ClientSidebar";
import { useSelector } from 'react-redux';
import AgentSidebar from "./Agent";

const Sidebar = () => {
  const role = useSelector((data) => data.auth.currentUser.role);

  return (
    <>
     {(role == "Admin") && <AdminSidebar/>}
     {(role === 2) && <ClientSidebar/>}
     {(role === 3) && <AgentSidebar/>}

    </>
  );
};

export default Sidebar;
